import type { LegacySubscription } from '../../types';

export function getSeatLimit(legacySubscription: LegacySubscription) {
  return legacySubscription.seatCount ?? 0;
}
